// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";

// const TEMPLATE_FILENAME = "CGD Company of the Year 2025-28.07final.xlsx";

// // row mapping: these MUST match your template rows exactly
// const rowMapping = {
//   organisationname: 5,
//   MWP_10: 4,
//   MWP_8: 5,
//   MWP_5: 6,
//   MWP_3: 7,
//   MWP_no: 8,
//   basedate: 10,
//   start_date: 11,
//   period: 12,
//   force_start: 13,
//   force_end: 14,
//   mwp_target_png: 17,
//   pro_rated_MWP: 18,
//   actual_png: 19,
//   billed_png: 20,
//   mwp_target_cng: 23,
//   pro_rated_MWP_cng: 24,
//   actual_cng: 25,
//   mwp_target_inch: 28,
//   pro_rated_MWP_inch: 29,
//   actual_inch: 30,
//   png_sales: 33,
//   cng_sales: 34,
//   cbg_intakes: 35,
//   fatalities: 37,
//   hours_workout: 38,
//   lost_time: 39,
//   incidents: 40,
//   safety: 41,
// };

// const colLetter = (colIndex) => {
//   let letters = "";
//   while (colIndex >= 0) {
//     letters = String.fromCharCode((colIndex % 26) + 65) + letters;
//     colIndex = Math.floor(colIndex / 26) - 1;
//   }
//   return letters;
// };

// const colIndexFromLetter = (col) => {
//   let index = 0;
//   for (let i = 0; i < col.length; i++) {
//     index = index * 26 + (col.charCodeAt(i) - 65 + 1);
//   }
//   return index - 1;
// };

// const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
//   const start = `${colLetter(minCol)}${minRow}`;
//   const end = `${colLetter(maxCol)}${maxRow}`;
//   sheet["!ref"] = `${start}:${end}`;
// };

// const ExcelCGD = () => {
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [exported, setExported] = useState(false);
//   const [lastExportAt, setLastExportAt] = useState(null);

//   // CONFIG
//   const START_COL = 3; // zero-based (3 => column D).
//   const sheetName = "Calculation - Company A"; // exact sheet name
//   const APPEND_IF_NONEMPTY = true; // <-- set to false to always overwrite

//   useEffect(() => {
//     (async () => {
//       try {
//         const resp = await apiClient.get("/registration-cgd/submitted/");
//         const results = (resp.data && (resp.data.results ?? resp.data)) || [];
//         console.log("API results length:", results.length);
//         console.log("Sample API object (0):", results[0]);
//         setApiData(results);
//       } catch (err) {
//         console.error("API fetch error:", err);
//         setError("Failed to fetch API data. See console.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     if (!loading && !error && apiData && apiData.length > 0 && !exported) {
//       (async () => {
//         try {
//           await performExport(apiData);
//           setExported(true);
//           setLastExportAt(new Date());
//         } catch (err) {
//           console.error("Auto-export failed:", err);
//         }
//       })();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, error, apiData, exported]);

//   const getVal = (obj, ...keys) => {
//     for (const k of keys) {
//       if (!k) continue;
//       if (k.includes(".")) {
//         const parts = k.split(".");
//         let cur = obj;
//         for (const p of parts) {
//           if (cur == null) {
//             cur = undefined;
//             break;
//           }
//           cur = cur[p];
//         }
//         if (cur !== undefined && cur !== null) return cur;
//       } else {
//         const val = obj[k];
//         if (val !== undefined && val !== null) return val;
//       }
//     }
//     return undefined;
//   };

//   const resolveMergeCell = (sheet, r, c) => {
//     const merges = sheet["!merges"] || [];
//     for (const m of merges) {
//       if (r >= m.s.r && r <= m.e.r && c >= m.s.c && c <= m.e.c) {
//         return { r: m.s.r, c: m.s.c };
//       }
//     }
//     return { r, c };
//   };

//   // find the next empty row (1-based row number) in column cZero, starting searching from startRow (1-based)
//   const findNextEmptyRow = (sheet, cZero, startRow) => {
//     // check up to some large limit to avoid infinite loops
//     const MAX_CHECK = 10000;
//     let r = startRow;
//     for (let i = 0; i < MAX_CHECK; i++, r++) {
//       const addr = `${colLetter(cZero)}${r}`;
//       const cell = sheet[addr];
//       if (!cell || cell.v === undefined || cell.v === null || cell.v === "") {
//         return r;
//       }
//     }
//     // fallback: return startRow (if none found)
//     return startRow;
//   };

//   const performExport = async (dataToWrite) => {
//     if (!dataToWrite || dataToWrite.length === 0) {
//       throw new Error("No API data to export.");
//     }

//     const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
//     console.log("Fetching template:", url);
//     const resp = await fetch(url);
//     if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

//     const contentType = resp.headers.get("content-type") || "";
//     if (contentType.includes("text/html")) {
//       const txt = await resp.text();
//       console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
//       throw new Error("Template returned HTML. Check file path/name.");
//     }

//     const arrayBuffer = await resp.arrayBuffer();
//     const workbook = XLSX.read(arrayBuffer, { type: "array" });

//     const sheet = workbook.Sheets[sheetName];
//     if (!sheet) {
//       throw new Error(`Sheet "${sheetName}" not found in workbook. Available: ${workbook.SheetNames.join(", ")}`);
//     }
//     console.log("Using sheet:", sheetName, "initial !ref:", sheet["!ref"]);
//     console.log("Sheet merges (if any):", sheet["!merges"] || []);

//     // existing bounds
//     const existingRef = sheet["!ref"] || "A1:A1";
//     const [startRef, endRef] = existingRef.split(":");
//     const startColLetter = (startRef || "A1").replace(/[0-9]/g, "");
//     const startRow = parseInt((startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;
//     const endColLetter = (endRef || startRef || "A1").replace(/[0-9]/g, "");
//     const endRow = parseInt((endRef || startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;

//     let minCol = colIndexFromLetter(startColLetter || "A"); // zero-based
//     let minRow = startRow; // 1-based
//     let maxCol = colIndexFromLetter(endColLetter || "A"); // zero-based
//     let maxRow = endRow; // 1-based

//     const readCell = (rZero, cZero) => {
//       const addr = `${colLetter(cZero)}${rZero + 1}`;
//       return sheet[addr] ? sheet[addr].v : undefined;
//     };

//     // iterate companies and write each into its column(s)
//     dataToWrite.forEach((company, idx) => {
//       const baseColIndex = START_COL + idx; // zero-based base column for this company
//       const baseColLetter = colLetter(baseColIndex);
//       console.log(
//         `\n--- Writing company #${idx + 1} starting at base column ${baseColLetter} (index ${baseColIndex}) ---`
//       );
//       console.log("Company keys sample:", Object.keys(company).slice(0, 40));

//       const getValLocal = (obj, ...keys) => getVal(obj, ...keys);

//       // collect top-level scalar/array fields
//       const organisationname = getValLocal(company, "organisation_name", "organisationname", "org_name", "organisation", "name");
//       const basedate = getValLocal(company, "baseDate", "basedate") ?? "";
//       const start_date = getValLocal(company, "startWorkDate", "start_date");
//       const period = getValLocal(company, "exclusivityPeriod", "period");
//       const force_start = getValLocal(company, "forceMajeureStart", "force_start");
//       const force_end = getValLocal(company, "forceMajeureEnd", "force_end");

//       const mwp_target_png = getValLocal(company, "pngTotalMWP", "mwp_target_png");
//       const pro_rated_MWP = getValLocal(company, "pngProRatedMWP", "pro_rated_MWP");
//       const actual_png = getValLocal(company, "pngActual", "actual_png");
//       const billed_png = getValLocal(company, "pngBilled", "billed_png");

//       const mwp_target_cng = getValLocal(company, "cngTotalMWP", "mwp_target_cng");
//       const pro_rated_MWP_cng = getValLocal(company, "cngProRatedMWP", "pro_rated_MWP_cng");
//       const actual_cng = getValLocal(company, "cngActual", "actual_cng");

//       const mwp_target_inch = getValLocal(company, "pipelineTotalMWP", "mwp_target_inch");
//       const pro_rated_MWP_inch = getValLocal(company, "pipelineProRatedMWP", "pro_rated_MWP_inch");
//       const actual_inch = getValLocal(company, "pipelineActual", "actual_inch");

//       const png_sales = getValLocal(company, "pngSalesVolume", "png_sales");
//       const cng_sales = getValLocal(company, "cngSalesVolume", "cng_sales");
//       const cbg_intakes = getValLocal(company, "cbgIntake", "cbg_intakes");
//       const fatalities = getValLocal(company, "fatalities");
//       const hours_workout = getValLocal(company, "totalHoursWorked", "hours_workout");
//       const lost_time = getValLocal(company, "lostTimeInjuries", "lost_time");
//       const safety = getValLocal(company, "safetyAudits", "safety");
//       const incidents = getValLocal(company, "totalRecordableIncident", "incidents");

//       const scalarWrites = [
//         [rowMapping.organisationname, organisationname, "organisationname"],
//         [rowMapping.basedate, basedate, "basedate"],
//         [rowMapping.start_date, start_date, "start_date"],
//         [rowMapping.period, period, "period"],
//         [rowMapping.force_start, force_start, "force_start"],
//         [rowMapping.force_end, force_end, "force_end"],
//         [rowMapping.mwp_target_png, mwp_target_png, "mwp_target_png"],
//         [rowMapping.pro_rated_MWP, pro_rated_MWP, "pro_rated_MWP"],
//         [rowMapping.actual_png, actual_png, "actual_png"],
//         [rowMapping.billed_png, billed_png, "billed_png"],
//         [rowMapping.mwp_target_cng, mwp_target_cng, "mwp_target_cng"],
//         [rowMapping.pro_rated_MWP_cng, pro_rated_MWP_cng, "pro_rated_MWP_cng"],
//         [rowMapping.actual_cng, actual_cng, "actual_cng"],
//         [rowMapping.mwp_target_inch, mwp_target_inch, "mwp_target_inch"],
//         [rowMapping.pro_rated_MWP_inch, pro_rated_MWP_inch, "pro_rated_MWP_inch"],
//         [rowMapping.actual_inch, actual_inch, "actual_inch"],
//         [rowMapping.png_sales, png_sales, "png_sales"],
//         [rowMapping.cng_sales, cng_sales, "cng_sales"],
//         [rowMapping.cbg_intakes, cbg_intakes, "cbg_intakes"],
//         [rowMapping.fatalities, fatalities, "fatalities"],
//         [rowMapping.hours_workout, hours_workout, "hours_workout"],
//         [rowMapping.lost_time, lost_time, "lost_time"],
//         [rowMapping.incidents, incidents, "incidents"],
//         [rowMapping.safety, safety, "safety"],
//       ];

//       // 1) array-of-objects detection: top-level properties that are arrays whose elements are objects
//       const topLevelKeys = Object.keys(company || {});
//       const arrayObjectKeys = topLevelKeys.filter((k) => Array.isArray(company[k]) && company[k].length > 0 && typeof company[k][0] === "object");

//       let maxArrayObjLen = 0;
//       arrayObjectKeys.forEach((arrKey) => {
//         maxArrayObjLen = Math.max(maxArrayObjLen, company[arrKey].length);
//       });

//       // For each array-of-objects key, write properties of element j into column baseColIndex + j
//       arrayObjectKeys.forEach((arrKey) => {
//         const arr = company[arrKey];
//         arr.forEach((elementObj, elemIdx) => {
//           const targetCol = baseColIndex + elemIdx;
//           Object.keys(elementObj || {}).forEach((prop) => {
//             if (rowMapping[prop] == null) {
//               // property not in rowMapping -> skip
//               console.debug(`Skipping property "${prop}" from ${arrKey}[${elemIdx}] because not in rowMapping.`);
//               return;
//             }

//             const rowNum = rowMapping[prop];
//             let rZero = rowNum - 1;
//             // resolve merges for original target
//             let { r: rResolved, c: cResolved } = resolveMergeCell(sheet, rZero, targetCol);

//             // If append behavior: find appropriate row to write into
//             let writeRow1Based = rResolved + 1;
//             if (APPEND_IF_NONEMPTY) {
//               const addr = `${colLetter(cResolved)}${writeRow1Based}`;
//               const cell = sheet[addr];
//               if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//                 const nextEmpty = findNextEmptyRow(sheet, cResolved, writeRow1Based);
//                 console.log(`Target ${addr} occupied, appending ${prop} from ${arrKey}[${elemIdx}] to ${colLetter(cResolved)}${nextEmpty}`);
//                 writeRow1Based = nextEmpty;
//                 // if the merged region mapped to top-left above, respect top-left column; writing to new row will be unmerged cell
//                 rResolved = writeRow1Based - 1;
//               } else {
//                 // free; write to rResolved
//                 writeRow1Based = rResolved + 1;
//               }
//             }

//             let writeVal = elementObj[prop];
//             if (writeVal === undefined || writeVal === null) writeVal = "";
//             if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//             if (typeof writeVal === "string") {
//               const noCommas = writeVal.trim().replace(/,/g, "");
//               if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//             }

//             const finalRZero = writeRow1Based - 1;
//             const finalCZero = cResolved;

//             console.log(
//               "BEFORE WRITE (arrayObj)",
//               `${arrKey}.${prop}[${elemIdx}]`,
//               "addr:",
//               `${colLetter(finalCZero)}${finalRZero + 1}`,
//               "current:",
//               readCell(finalRZero, finalCZero),
//               "-> writing:",
//               writeVal
//             );

//             try {
//               XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//               const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//               const newCell = sheet[cellAddr];
//               if (newCell) {
//                 if (typeof writeVal === "number") newCell.t = "n";
//                 else if (typeof writeVal === "boolean") newCell.t = "b";
//                 else newCell.t = "s";
//               }
//               console.log(`WROTE (arrayObj) ${arrKey}.${prop}[${elemIdx}] -> ${cellAddr} =`, writeVal);
//             } catch (e) {
//               console.error("Write failed for (arrayObj)", arrKey, prop, "at", finalRZero, finalCZero, e);
//               const fallbackCellRef = `${colLetter(finalCZero)}${rowNum}`;
//               sheet[fallbackCellRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//             }

//             if (finalCZero > maxCol) maxCol = finalCZero;
//             if (finalRZero + 1 > maxRow) maxRow = Math.max(maxRow, finalRZero + 1);
//           });
//         });
//       });

//       // 2) scalars & arrays-of-primitives handling
//       scalarWrites.forEach(([rowNum, value, fieldName]) => {
//         if (rowNum == null) return;
//         const rZero = rowNum - 1;

//         // arrays-of-primitives => write horizontally (elem0 -> baseColIndex, elem1 -> base+1, etc.)
//         if (Array.isArray(value) && value.length > 0 && typeof value[0] !== "object") {
//           console.log(`Field "${fieldName}" is primitive array (len=${value.length}) -> writing horizontally starting at ${colLetter(baseColIndex)}.`);
//           value.forEach((elem, elemIdx) => {
//             let targetCol = baseColIndex + elemIdx;

//             // resolve merges for the base row in this column
//             let { r: rResolved, c: cResolved } = resolveMergeCell(sheet, rZero, targetCol);
//             let writeRow1Based = rResolved + 1;

//             if (APPEND_IF_NONEMPTY) {
//               const addr = `${colLetter(cResolved)}${writeRow1Based}`;
//               const cell = sheet[addr];
//               if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//                 const nextEmpty = findNextEmptyRow(sheet, cResolved, writeRow1Based);
//                 console.log(`Primitive-array target ${addr} occupied, appending ${fieldName}[${elemIdx}] to ${colLetter(cResolved)}${nextEmpty}`);
//                 writeRow1Based = nextEmpty;
//               }
//             }

//             let writeVal = elem === undefined || elem === null ? "" : elem;
//             if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//             if (typeof writeVal === "string") {
//               const trimmed = writeVal.trim();
//               const noCommas = trimmed.replace(/,/g, "");
//               if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//             }

//             const finalRZero = writeRow1Based - 1;
//             const finalCZero = cResolved;

//             console.log("BEFORE WRITE (primArray)", fieldName, `elemIdx=${elemIdx}`, "addr:", `${colLetter(finalCZero)}${finalRZero + 1}`, "current:", readCell(finalRZero, finalCZero), "-> writing:", writeVal);

//             try {
//               XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//               const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//               const newCell = sheet[cellAddr];
//               if (newCell) {
//                 if (typeof writeVal === "number") newCell.t = "n";
//                 else if (typeof writeVal === "boolean") newCell.t = "b";
//                 else newCell.t = "s";
//               }
//               console.log(`WROTE (primArray) ${fieldName}[${elemIdx}] -> ${cellAddr} =`, writeVal);
//             } catch (e) {
//               console.error("Write failed for (primArray)", fieldName, "at", finalRZero, finalCZero, e);
//               const fallbackCellRef = `${colLetter(finalCZero)}${rowNum}`;
//               sheet[fallbackCellRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//             }

//             if (finalCZero > maxCol) maxCol = finalCZero;
//             if (rowNum > maxRow) maxRow = Math.max(maxRow, rowNum);
//           });
//         } else {
//           // scalar write to base column (with append-if-nonempty)
//           const targetCol = baseColIndex;
//           let { r: rResolved, c: cResolved } = resolveMergeCell(sheet, rZero, targetCol);
//           let writeRow1Based = rResolved + 1;

//           if (APPEND_IF_NONEMPTY) {
//             const addr = `${colLetter(cResolved)}${writeRow1Based}`;
//             const cell = sheet[addr];
//             if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//               const nextEmpty = findNextEmptyRow(sheet, cResolved, writeRow1Based);
//               console.log(`Scalar target ${addr} occupied, appending ${fieldName} to ${colLetter(cResolved)}${nextEmpty}`);
//               writeRow1Based = nextEmpty;
//             }
//           }

//           let writeVal = value;
//           if (writeVal === undefined || writeVal === null || writeVal === "") {
//             writeVal = "";
//           }
//           if (Array.isArray(writeVal)) writeVal = writeVal.length ? writeVal.join(", ") : "";
//           if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//           if (typeof writeVal === "string") {
//             const trimmed = writeVal.trim();
//             const noCommas = trimmed.replace(/,/g, "");
//             if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//           }

//           const finalRZero = writeRow1Based - 1;
//           const finalCZero = cResolved;

//           console.log("BEFORE WRITE (scalar)", fieldName, "addr:", `${colLetter(finalCZero)}${finalRZero + 1}`, "current:", readCell(finalRZero, finalCZero), "-> writing:", writeVal);

//           try {
//             XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//             const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//             const newCell = sheet[cellAddr];
//             if (newCell) {
//               if (typeof writeVal === "number") newCell.t = "n";
//               else if (typeof writeVal === "boolean") newCell.t = "b";
//               else newCell.t = "s";
//             }
//             console.log(`WROTE (scalar) ${fieldName} -> ${cellAddr} =`, writeVal);
//           } catch (e) {
//             console.error("Write failed for (scalar)", fieldName, "at", finalRZero, finalCZero, e);
//             const fallbackCellRef = `${colLetter(finalCZero)}${rowNum}`;
//             sheet[fallbackCellRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//           }

//           if (finalCZero > maxCol) maxCol = finalCZero;
//           if (rowNum > maxRow) maxRow = Math.max(maxRow, rowNum);
//         }
//       });

//       // Debug dump: show base column and next few columns for verification
//       const dumpCols = Math.max(3, maxArrayObjLen || 0);
//       console.log(`AFTER DUMP for columns ${colLetter(baseColIndex)}..${colLetter(baseColIndex + dumpCols)} (rows 1..20):`);
//       for (let r = 1; r <= 20; r++) {
//         let rowDump = `${r}: `;
//         for (let c = baseColIndex; c <= baseColIndex + dumpCols; c++) {
//           const addr = `${colLetter(c)}${r}`;
//           rowDump += `${addr}=${sheet[addr] ? sheet[addr].v : "undefined"}; `;
//         }
//         console.log(rowDump);
//       }
//     });

//     // update sheet range so Excel shows new cells (maxCol is zero-based, maxRow is 1-based)
//     expandSheetRange(sheet, minCol, minRow, Math.max(maxCol, minCol), Math.max(maxRow, minRow));
//     console.log("Updated sheet !ref:", sheet["!ref"]);

//     const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//     saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
//     console.log("Excel exported successfully.");
//   };

//   const handleManualExport = async () => {
//     try {
//       await performExport(apiData);
//       setExported(true);
//       setLastExportAt(new Date());
//     } catch (err) {
//       console.error("Manual export failed:", err);
//       alert("Export failed — see console for details.");
//     }
//   };

//   if (loading) return <div>Loading API data...</div>;
//   if (error) return <div style={{ color: "red" }}>{error}</div>;

//   return (
//     <div style={{ padding: 12 }}>
//       <h3>Excel CGD Exporter</h3>
//       <div style={{ marginBottom: 8 }}>
//         <button onClick={handleManualExport} style={{ padding: "8px 12px" }}>
//           Export now
//         </button>{" "}
//         {exported && lastExportAt && <small>Last exported: {lastExportAt.toLocaleString()}</small>}
//       </div>

//       <div style={{ marginTop: 8 }}>
//         <strong>Configuration</strong>
//         <div>Template filename: {TEMPLATE_FILENAME}</div>
//         <div>Sheet name: {sheetName}</div>
//         <div>
//           Start column (zero-based): {START_COL} → {colLetter(START_COL)} • Append mode: {APPEND_IF_NONEMPTY ? "ON" : "OFF"}
//         </div>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <strong>API sample (first object)</strong>
//         <pre style={{ maxHeight: 240, overflow: "auto", background: "#f6f6f6", padding: 8 }}>
//           {apiData && apiData.length > 0 ? JSON.stringify(apiData[0], null, 2) : "No data"}
//         </pre>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <small>
//           Check the browser console for detailed logs showing append decisions, BEFORE/AFTER writes, and the updated sheet range.
//         </small>
//       </div>
//     </div>
//   );
// };

// export default ExcelCGD;


// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";

// const TEMPLATE_FILENAME = "CGD Company of the Year 2025-28.07final.xlsx";

// // exact row mapping (must match your template)
// const rowMapping = {
//   organisationname: 2,
//   MWP_10: 4,
//   MWP_8: 5,
//   MWP_5: 6,
//   MWP_3: 7,
//   MWP_no: 8,
//   basedate: 10,
//   start_date: 11,
//   period: 12,
//   force_start: 13,
//   force_end: 14,
//   mwp_target_png: 17,
//   pro_rated_MWP: 18,
//   actual_png: 19, // <-- adjust if your actual_png is row 10, change this value to 10
//   billed_png: 20,
//   mwp_target_cng: 23,
//   pro_rated_MWP_cng: 24,
//   actual_cng: 25,
//   mwp_target_inch: 28,
//   pro_rated_MWP_inch: 29,
//   actual_inch: 30,
//   png_sales: 33,
//   cng_sales: 34,
//   cbg_intakes: 35,
//   fatalities: 37,
//   hours_workout: 38,
//   lost_time: 39,
//   incidents: 40,
//   safety: 41,
// };

// // NOTE:
// // If actual_png should be row 10, change rowMapping.actual_png = 10 above.

// const aliasKeyMap = {
//   ga10YearMWP: "MWP_10",
//   ga8YearMWP: "MWP_8",
//   ga5YearMWP: "MWP_5",
//   ga3YearMWP: "MWP_3",
//   gaNoMWP: "MWP_no",
//   Organisation_name: "organisationname",
//   baseDate: "basedate",
//   startWorkDate: "start_date",
//   exclusivityPeriod: "period",
//   forceMajeureStart: "force_start",
//   forceMajeureEnd: "force_end",
//   pngTotalMWP: "mwp_target_png",
//   pngProRatedMWP: "pro_rated_MWP",
//   pngActual: "actual_png",
//   pngBilled: "billed_png",
//   cngTotalMWP: "mwp_target_cng",
//   cngProRatedMWP: "pro_rated_MWP_cng",
//   cngActual: "actual_cng",
//   pipelineTotalMWP: "mwp_target_inch",
//   pipelineProRatedMWP: "pro_rated_MWP_inch",
//   pipelineActual: "actual_inch",
//   pngSalesVolume: "png_sales",
//   cngSalesVolume: "cng_sales",
//   cbgIntake: "cbg_intakes",
//   fatalities: "fatalities",
//   totalHoursWorked: "hours_workout",
//   lostTimeInjuries: "lost_time",
//   totalRecordableIncident: "incidents",
//   safetyAudits: "safety",
// };

// const colLetter = (colIndex) => {
//   let letters = "";
//   while (colIndex >= 0) {
//     letters = String.fromCharCode((colIndex % 26) + 65) + letters;
//     colIndex = Math.floor(colIndex / 26) - 1;
//   }
//   return letters;
// };

// const colIndexFromLetter = (col) => {
//   let index = 0;
//   for (let i = 0; i < col.length; i++) {
//     index = index * 26 + (col.charCodeAt(i) - 65 + 1);
//   }
//   return index - 1;
// };

// const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
//   const start = `${colLetter(minCol)}${minRow}`;
//   const end = `${colLetter(maxCol)}${maxRow}`;
//   sheet["!ref"] = `${start}:${end}`;
// };

// const ExcelCGD = () => {
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [exported, setExported] = useState(false);
//   const [lastExportAt, setLastExportAt] = useState(null);

//   // CONFIG
//   const START_COL = 3; // zero-based (3 => column D)
//   const sheetName = "Calculation - Company A";
//   const APPEND_IF_NONEMPTY = true; // when ON, if target cell occupied, find next empty column to the right

//   useEffect(() => {
//     (async () => {
//       try {
//         const resp = await apiClient.get("/registration-cgd/submitted/");
//         const results = (resp.data && (resp.data.results ?? resp.data)) || [];
//         console.log("API results length:", results.length);
//         console.log("Sample API object (0):", results[0]);
//         setApiData(results);
//       } catch (err) {
//         console.error("API fetch error:", err);
//         setError("Failed to fetch API data. See console.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     if (!loading && !error && apiData && apiData.length > 0 && !exported) {
//       (async () => {
//         try {
//           await performExport(apiData);
//           setExported(true);
//           setLastExportAt(new Date());
//         } catch (err) {
//           console.error("Auto-export failed:", err);
//         }
//       })();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, error, apiData, exported]);

//   const getRowMappingForKey = (key) => {
//     if (!key) return undefined;
//     if (rowMapping[key] !== undefined) return rowMapping[key];
//     if (aliasKeyMap[key] && rowMapping[aliasKeyMap[key]] !== undefined) return rowMapping[aliasKeyMap[key]];
//     const normalized = key.toLowerCase().replace(/[^a-z0-9]/g, "");
//     for (const rk of Object.keys(rowMapping)) {
//       if (rk.toLowerCase().replace(/[^a-z0-9]/g, "") === normalized) return rowMapping[rk];
//     }
//     return undefined;
//   };

//   const resolveMergeCell = (sheet, r, c) => {
//     const merges = sheet["!merges"] || [];
//     for (const m of merges) {
//       if (r >= m.s.r && r <= m.e.r && c >= m.s.c && c <= m.e.c) {
//         return { r: m.s.r, c: m.s.c };
//       }
//     }
//     return { r, c };
//   };

//   // find the next empty row in column cZero (1-based rows), start searching from startRow
//   const findNextEmptyRow = (sheet, cZero, startRow) => {
//     const MAX_CHECK = 10000;
//     let r = startRow;
//     for (let i = 0; i < MAX_CHECK; i++, r++) {
//       const addr = `${colLetter(cZero)}${r}`;
//       const cell = sheet[addr];
//       if (!cell || cell.v === undefined || cell.v === null || cell.v === "") {
//         return r;
//       }
//     }
//     return startRow;
//   };

//   // find the next empty column (zero-based) in a given row (1-based rowNumber), starting from startColZero
//   const findNextEmptyCol = (sheet, rowOneBased, startColZero) => {
//     const MAX_CHECK = 10000;
//     let c = startColZero;
//     for (let i = 0; i < MAX_CHECK; i++, c++) {
//       const addr = `${colLetter(c)}${rowOneBased}`;
//       const cell = sheet[addr];
//       if (!cell || cell.v === undefined || cell.v === null || cell.v === "") {
//         return c;
//       }
//     }
//     return startColZero;
//   };

//   const performExport = async (dataToWrite) => {
//     if (!dataToWrite || dataToWrite.length === 0) {
//       throw new Error("No API data to export.");
//     }

//     const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
//     console.log("Fetching template:", url);
//     const resp = await fetch(url);
//     if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

//     const contentType = resp.headers.get("content-type") || "";
//     if (contentType.includes("text/html")) {
//       const txt = await resp.text();
//       console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
//       throw new Error("Template returned HTML. Check file path/name.");
//     }

//     const arrayBuffer = await resp.arrayBuffer();
//     const workbook = XLSX.read(arrayBuffer, { type: "array" });

//     const sheet = workbook.Sheets[sheetName];
//     if (!sheet) {
//       throw new Error(`Sheet "${sheetName}" not found in workbook. Available: ${workbook.SheetNames.join(", ")}`);
//     }
//     console.log("Using sheet:", sheetName, "initial !ref:", sheet["!ref"]);
//     console.log("Sheet merges (if any):", sheet["!merges"] || []);

//     // existing bounds
//     const existingRef = sheet["!ref"] || "A1:A1";
//     const [startRef, endRef] = existingRef.split(":");
//     const startColLetter = (startRef || "A1").replace(/[0-9]/g, "");
//     const startRow = parseInt((startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;
//     const endColLetter = (endRef || startRef || "A1").replace(/[0-9]/g, "");
//     const endRow = parseInt((endRef || startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;

//     let minCol = colIndexFromLetter(startColLetter || "A"); // zero-based
//     let minRow = startRow; // 1-based
//     let maxCol = colIndexFromLetter(endColLetter || "A"); // zero-based
//     let maxRow = endRow; // 1-based

//     const readCell = (rZero, cZero) => {
//       const addr = `${colLetter(cZero)}${rZero + 1}`;
//       return sheet[addr] ? sheet[addr].v : undefined;
//     };

//     // iterate companies and write each into its column(s)
//     dataToWrite.forEach((company, idx) => {
//       const baseColIndex = START_COL + idx; // contiguous columns per company
//       const baseColLetter = colLetter(baseColIndex);
//       console.log(`\n--- Writing company #${idx + 1} starting at base column ${baseColLetter} (index ${baseColIndex}) ---`);
//       console.log("Company keys sample:", Object.keys(company).slice(0, 40));

//       // For each key in the company object
//       Object.keys(company || {}).forEach((key) => {
//         const mappedRow = getRowMappingForKey(key);
//         if (mappedRow == null) {
//           // no mapping for this key — skip
//           return;
//         }

//         const value = company[key];

//         // If it's an array -> write horizontally across the mapped row starting at baseColIndex
//         if (Array.isArray(value)) {
//           // flatten one level so that inner arrays become consecutive columns
//           const flattened = value.flat(1);

//           console.log(`Key "${key}" is array -> writing horizontally on row ${mappedRow} starting at col ${colLetter(baseColIndex)}; total items=${flattened.length}`);

//           flattened.forEach((elem, elemIdx) => {
//             let targetCol = baseColIndex + elemIdx; // initial desired column
//             let writeRow1Based = mappedRow;
//             let writeVal = elem === undefined || elem === null ? "" : elem;

//             if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//             if (typeof writeVal === "string") {
//               const trimmed = writeVal.trim();
//               const noCommas = trimmed.replace(/,/g, "");
//               if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//             }

//             // respect merged cells: resolve merge using mappedRow and targetCol
//             let { r: rResolved, c: cResolved } = resolveMergeCell(sheet, mappedRow - 1, targetCol);
//             // cResolved gives canonical column for that merged region; we use it as starting column.
//             targetCol = cResolved;

//             // If append behavior and target occupied, find next empty column in same row starting from targetCol
//             if (APPEND_IF_NONEMPTY) {
//               const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//               const cell = sheet[addr];
//               if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//                 const nextEmptyCol = findNextEmptyCol(sheet, writeRow1Based, targetCol);
//                 console.log(`Target ${addr} occupied; appending ${key}[${elemIdx}] to ${colLetter(nextEmptyCol)}${writeRow1Based}`);
//                 targetCol = nextEmptyCol;
//               }
//             }

//             const finalRZero = writeRow1Based - 1;
//             const finalCZero = targetCol;

//             try {
//               XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//               const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//               const newCell = sheet[cellAddr];
//               if (newCell) {
//                 if (typeof writeVal === "number") newCell.t = "n";
//                 else if (typeof writeVal === "boolean") newCell.t = "b";
//                 else newCell.t = "s";
//               }
//               console.log(`WROTE (horiz) ${key}[${elemIdx}] -> ${cellAddr} =`, writeVal);
//             } catch (e) {
//               console.error("Write failed (horiz)", key, elemIdx, "at", finalRZero, finalCZero, e);
//               const fallbackRef = `${colLetter(finalCZero)}${mappedRow}`;
//               sheet[fallbackRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//             }

//             if (finalCZero > maxCol) maxCol = finalCZero;
//             if (finalRZero + 1 > maxRow) maxRow = Math.max(maxRow, finalRZero + 1);
//           });
//         } else {
//           // scalar -> write to mappedRow in base column (append if occupied)
//           let writeRow1Based = mappedRow;
//           let writeVal = value === undefined || value === null ? "" : value;
//           if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//           if (typeof writeVal === "string") {
//             const trimmed = writeVal.trim();
//             const noCommas = trimmed.replace(/,/g, "");
//             if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//           }

//           // resolve merges for mappedRow, baseColIndex
//           const { r: rResolved, c: cResolved } = resolveMergeCell(sheet, mappedRow - 1, baseColIndex);
//           let targetCol = cResolved;

//           if (APPEND_IF_NONEMPTY) {
//             const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//             const cell = sheet[addr];
//             if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//               const nextEmptyCol = findNextEmptyCol(sheet, writeRow1Based, targetCol);
//               console.log(`Scalar target ${addr} occupied -> appending ${key} to ${colLetter(nextEmptyCol)}${writeRow1Based}`);
//               targetCol = nextEmptyCol;
//             }
//           }

//           const finalRZero = writeRow1Based - 1;
//           const finalCZero = targetCol;

//           try {
//             XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//             const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//             const newCell = sheet[cellAddr];
//             if (newCell) {
//               if (typeof writeVal === "number") newCell.t = "n";
//               else if (typeof writeVal === "boolean") newCell.t = "b";
//               else newCell.t = "s";
//             }
//             console.log(`WROTE (scalar) ${key} -> ${cellAddr} =`, writeVal);
//           } catch (e) {
//             console.error("Write failed (scalar)", key, "at", finalRZero, finalCZero, e);
//             const fallbackRef = `${colLetter(finalCZero)}${mappedRow}`;
//             sheet[fallbackRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//           }

//           if (finalCZero > maxCol) maxCol = finalCZero;
//           if (finalRZero + 1 > maxRow) maxRow = Math.max(maxRow, finalRZero + 1);
//         }
//       }); // end keys loop

//       // debug dump for verification: show mapped rows in the company's block for first 20 columns
//       console.log(`AFTER DUMP for columns ${colLetter(baseColIndex)}..${colLetter(baseColIndex + 20)} (rows 1..20):`);
//       for (let r = 1; r <= 20; r++) {
//         let rowDump = `${r}: `;
//         for (let c = baseColIndex; c <= baseColIndex + 20; c++) {
//           const addr = `${colLetter(c)}${r}`;
//           rowDump += `${addr}=${sheet[addr] ? sheet[addr].v : "undefined"}; `;
//         }
//         console.log(rowDump);
//       }
//     }); // end companies loop

//     // update sheet range so Excel shows new cells
//     expandSheetRange(sheet, minCol, minRow, Math.max(maxCol, minCol), Math.max(maxRow, minRow));
//     console.log("Updated sheet !ref:", sheet["!ref"]);

//     const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//     saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
//     console.log("Excel exported successfully.");
//   };

//   const handleManualExport = async () => {
//     try {
//       await performExport(apiData);
//       setExported(true);
//       setLastExportAt(new Date());
//     } catch (err) {
//       console.error("Manual export failed:", err);
//       alert("Export failed — see console for details.");
//     }
//   };

//   if (loading) return <div>Loading API data...</div>;
//   if (error) return <div style={{ color: "red" }}>{error}</div>;

//   return (
//     <div style={{ padding: 12 }}>
//       <h3>Excel CGD Exporter</h3>
//       <div style={{ marginBottom: 8 }}>
//         <button onClick={handleManualExport} style={{ padding: "8px 12px" }}>
//           Export now
//         </button>{" "}
//         {exported && lastExportAt && <small>Last exported: {lastExportAt.toLocaleString()}</small>}
//       </div>

//       <div style={{ marginTop: 8 }}>
//         <strong>Configuration</strong>
//         <div>Template filename: {TEMPLATE_FILENAME}</div>
//         <div>Sheet name: {sheetName}</div>
//         <div>
//           Start column (zero-based): {START_COL} → {colLetter(START_COL)} • Append mode: {APPEND_IF_NONEMPTY ? "ON" : "OFF"}
//         </div>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <strong>API sample (first object)</strong>
//         <pre style={{ maxHeight: 240, overflow: "auto", background: "#f6f6f6", padding: 8 }}>
//           {apiData && apiData.length > 0 ? JSON.stringify(apiData[0], null, 2) : "No data"}
//         </pre>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <small>
//           Check the browser console for detailed logs showing append decisions, BEFORE/AFTER writes, and the updated sheet range.
//         </small>
//       </div>
//     </div>
//   );
// };

// export default ExcelCGD;


// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";

// const TEMPLATE_FILENAME = "CGD Company of the Year 2025-28.07final.xlsx";

// // exact row mapping (must match your template)
// const rowMapping = {
//   organisationname: 2,
//   MWP_10: 4,
//   MWP_8: 5,
//   MWP_5: 6,
//   MWP_3: 7,
//   MWP_no: 8,
//   basedate: 10,
//   start_date: 11,
//   period: 12,
//   force_start: 13,
//   force_end: 14,
//   mwp_target_png: 17,
//   pro_rated_MWP: 18,
//   actual_png: 19, // adjust if needed
//   billed_png: 20,
//   mwp_target_cng: 23,
//   pro_rated_MWP_cng: 24,
//   actual_cng: 25,
//   mwp_target_inch: 28,
//   pro_rated_MWP_inch: 29,
//   actual_inch: 30,
//   png_sales: 33,
//   cng_sales: 34,
//   cbg_intakes: 35,
//   fatalities: 37,
//   hours_workout: 38,
//   lost_time: 39,
//   incidents: 40,
//   safety: 41,
// };

// const aliasKeyMap = {
//   ga10YearMWP: "MWP_10",
//   ga8YearMWP: "MWP_8",
//   ga5YearMWP: "MWP_5",
//   ga3YearMWP: "MWP_3",
//   gaNoMWP: "MWP_no",
//   Organisation_name: "organisationname",
//   gaNames: "organisationname",
//   organisation_name: "organisationname",
//   organisationname: "organisationname",
//   baseDate: "basedate",
//   startWorkDate: "start_date",
//   exclusivityPeriod: "period",
//   forceMajeureStart: "force_start",
//   forceMajeureEnd: "force_end",
//   pngTotalMWP: "mwp_target_png",
//   pngProRatedMWP: "pro_rated_MWP",
//   pngActual: "actual_png",
//   pngBilled: "billed_png",
//   cngTotalMWP: "mwp_target_cng",
//   cngProRatedMWP: "pro_rated_MWP_cng",
//   cngActual: "actual_cng",
//   pipelineTotalMWP: "mwp_target_inch",
//   pipelineProRatedMWP: "pro_rated_MWP_inch",
//   pipelineActual: "actual_inch",
//   pngSalesVolume: "png_sales",
//   cngSalesVolume: "cng_sales",
//   cbgIntake: "cbg_intakes",
//   fatalities: "fatalities",
//   totalHoursWorked: "hours_workout",
//   lostTimeInjuries: "lost_time",
//   totalRecordableIncident: "incidents",
//   safetyAudits: "safety",
// };

// const colLetter = (colIndex) => {
//   let letters = "";
//   while (colIndex >= 0) {
//     letters = String.fromCharCode((colIndex % 26) + 65) + letters;
//     colIndex = Math.floor(colIndex / 26) - 1;
//   }
//   return letters;
// };

// const colIndexFromLetter = (col) => {
//   let index = 0;
//   for (let i = 0; i < col.length; i++) {
//     index = index * 26 + (col.charCodeAt(i) - 65 + 1);
//   }
//   return index - 1;
// };

// const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
//   const start = `${colLetter(minCol)}${minRow}`;
//   const end = `${colLetter(maxCol)}${maxRow}`;
//   sheet["!ref"] = `${start}:${end}`;
// };

// const sanitizeSheetName = (name) => {
//   if (!name) return "Calculation";
//   let s = String(name).replace(/[\[\]\*\/\\\?\:]/g, " ").trim();
//   if (s.length === 0) s = "Calculation";
//   if (s.length > 28) s = s.slice(0, 28);
//   return `Calc - ${s}`;
// };

// const ExcelCGD = () => {
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [exported, setExported] = useState(false);
//   const [lastExportAt, setLastExportAt] = useState(null);

//   // CONFIG
//   const START_COL = 3; // zero-based (3 => column D)
//   const sheetName = "Calculation - Company A"; // template sheet name to copy
//   const APPEND_IF_NONEMPTY = true; // when ON, if target occupied, find next empty column in same row

//   useEffect(() => {
//     (async () => {
//       try {
//         const resp = await apiClient.get("/registration-cgd/submitted/");
//         const results = (resp.data && (resp.data.results ?? resp.data)) || [];
//         console.log("API results length:", results.length);
//         console.log("Sample API object (0):", results[0]);
//         setApiData(results);
//       } catch (err) {
//         console.error("API fetch error:", err);
//         setError("Failed to fetch API data. See console.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     if (!loading && !error && apiData && apiData.length > 0 && !exported) {
//       (async () => {
//         try {
//           await performExport(apiData);
//           setExported(true);
//           setLastExportAt(new Date());
//         } catch (err) {
//           console.error("Auto-export failed:", err);
//         }
//       })();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, error, apiData, exported]);

//   const getRowMappingForKey = (key) => {
//     if (!key) return undefined;
//     if (rowMapping[key] !== undefined) return rowMapping[key];
//     if (aliasKeyMap[key] && rowMapping[aliasKeyMap[key]] !== undefined)
//       return rowMapping[aliasKeyMap[key]];
//     const normalized = key.toLowerCase().replace(/[^a-z0-9]/g, "");
//     for (const rk of Object.keys(rowMapping)) {
//       if (rk.toLowerCase().replace(/[^a-z0-9]/g, "") === normalized) return rowMapping[rk];
//     }
//     return undefined;
//   };

//   const resolveMergeCell = (sheet, r, c) => {
//     const merges = sheet["!merges"] || [];
//     for (const m of merges) {
//       if (r >= m.s.r && r <= m.e.r && c >= m.s.c && c <= m.e.c) {
//         return { r: m.s.r, c: m.s.c };
//       }
//     }
//     return { r, c };
//   };

//   // find the next empty column (zero-based) in a given row (1-based rowNumber), starting from startColZero
//   const findNextEmptyCol = (sheet, rowOneBased, startColZero) => {
//     const MAX_CHECK = 10000;
//     let c = startColZero;
//     for (let i = 0; i < MAX_CHECK; i++, c++) {
//       const addr = `${colLetter(c)}${rowOneBased}`;
//       const cell = sheet[addr];
//       if (!cell || cell.v === undefined || cell.v === null || cell.v === "") {
//         return c;
//       }
//     }
//     return startColZero;
//   };

//   const performExport = async (dataToWrite) => {
//     if (!dataToWrite || dataToWrite.length === 0) {
//       throw new Error("No API data to export.");
//     }

//     const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
//     console.log("Fetching template:", url);
//     const resp = await fetch(url);
//     if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

//     const contentType = resp.headers.get("content-type") || "";
//     if (contentType.includes("text/html")) {
//       const txt = await resp.text();
//       console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
//       throw new Error("Template returned HTML. Check file path/name.");
//     }

//     const arrayBuffer = await resp.arrayBuffer();
//     const workbook = XLSX.read(arrayBuffer, { type: "array" });

//     const templateSheet = workbook.Sheets[sheetName];
//     if (!templateSheet) {
//       throw new Error(
//         `Sheet "${sheetName}" not found in workbook. Available: ${workbook.SheetNames.join(", ")}`
//       );
//     }
//     console.log("Using template sheet:", sheetName, "initial !ref:", templateSheet["!ref"]);

//     // define existingRef from template so it's available later
//     const existingRef = templateSheet["!ref"] || "A1:A1";

//     // We'll keep the template sheet in place, and add copies for each company.
//     // Track new sheet names to avoid collisions:
//     const usedNames = new Set(workbook.SheetNames);

//     // helper to deep-copy the template sheet object (preserves merges, cell addresses, etc.)
//     const cloneSheet = (sheet) => JSON.parse(JSON.stringify(sheet));

//     let globalMaxCol = 0;
//     let globalMaxRow = 0;

//     // write one company into a sheet (sheetObj is a writable sheet object)
//     const writeCompanyIntoSheet = (company, sheetObj, baseColIndex) => {
//       // helper to read cell value (rZero, cZero)
//       const readCell = (rZero, cZero) => {
//         const addr = `${colLetter(cZero)}${rZero + 1}`;
//         return sheetObj[addr] ? sheetObj[addr].v : undefined;
//       };

//       const companyKeys = Object.keys(company || {});
//       console.log("Writing into sheet; keys:", companyKeys.slice(0, 40));

//       // For each key in the company object
//       companyKeys.forEach((key) => {
//         const mappedRow = getRowMappingForKey(key);
//         if (mappedRow == null) return; // no mapping, skip

//         const value = company[key];

//         // array -> write horizontally across mappedRow (flatten one level)
//         if (Array.isArray(value)) {
//           const flattened = value.flat(1);
//           flattened.forEach((elem, elemIdx) => {
//             let targetCol = baseColIndex + elemIdx;
//             const writeRow1Based = mappedRow;
//             let writeVal = elem === undefined || elem === null ? "" : elem;

//             if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//             if (typeof writeVal === "string") {
//               const trimmed = writeVal.trim();
//               const noCommas = trimmed.replace(/,/g, "");
//               if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//             }

//             // resolve merges for mappedRow, targetCol
//             const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
//             targetCol = cResolved;

//             if (APPEND_IF_NONEMPTY) {
//               const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//               const cell = sheetObj[addr];
//               if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//                 const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
//                 console.log(`Occupied ${addr} -> using ${colLetter(nextEmptyCol)}${writeRow1Based}`);
//                 targetCol = nextEmptyCol;
//               }
//             }

//             const finalRZero = writeRow1Based - 1;
//             const finalCZero = targetCol;

//             try {
//               XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//               const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//               const newCell = sheetObj[cellAddr];
//               if (newCell) {
//                 if (typeof writeVal === "number") newCell.t = "n";
//                 else if (typeof writeVal === "boolean") newCell.t = "b";
//                 else newCell.t = "s";
//               }
//             } catch (e) {
//               console.error("Failed writing array cell", key, elemIdx, e);
//               sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
//                 t: typeof writeVal === "number" ? "n" : "s",
//                 v: writeVal,
//               };
//             }

//             globalMaxCol = Math.max(globalMaxCol, finalCZero);
//             globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
//           });
//         } else {
//           // scalar: write into mappedRow at baseColIndex (append to next empty column if needed)
//           let targetCol = baseColIndex;
//           let writeRow1Based = mappedRow;
//           let writeVal = value === undefined || value === null ? "" : value;
//           if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//           if (typeof writeVal === "string") {
//             const trimmed = writeVal.trim();
//             const noCommas = trimmed.replace(/,/g, "");
//             if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//           }

//           const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
//           targetCol = cResolved;

//           if (APPEND_IF_NONEMPTY) {
//             const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//             const cell = sheetObj[addr];
//             if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//               const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
//               targetCol = nextEmptyCol;
//             }
//           }

//           const finalRZero = writeRow1Based - 1;
//           const finalCZero = targetCol;

//           try {
//             XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//             const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//             const newCell = sheetObj[cellAddr];
//             if (newCell) {
//               if (typeof writeVal === "number") newCell.t = "n";
//               else if (typeof writeVal === "boolean") newCell.t = "b";
//               else newCell.t = "s";
//             }
//           } catch (e) {
//             console.error("Failed writing scalar", key, e);
//             sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
//               t: typeof writeVal === "number" ? "n" : "s",
//               v: writeVal,
//             };
//           }

//           globalMaxCol = Math.max(globalMaxCol, finalCZero);
//           globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
//         }
//       }); // end keys loop
//     }; // end writeCompanyIntoSheet

//     // For each company create a copy of the template sheet, name it, and write into it
//     dataToWrite.forEach((company, compIdx) => {
//       // decide sheet name using organisation name hints
//       const orgNameCandidates = [
//         company.Organisation_name,
//         company.org_name,
//         company.organisation_name,
//         company.organisationname,
//         company.gaNames && Array.isArray(company.gaNames) ? company.gaNames[0] : undefined,
//         company.gaNames,
//       ];
//       let orgName = orgNameCandidates.find((v) => v && typeof v === "string" && v.trim().length > 0);
//       if (!orgName) {
//         if (Array.isArray(company.gaNames) && company.gaNames.length > 0) orgName = company.gaNames[0];
//       }
//       const baseSheetName = sanitizeSheetName(orgName || `Company ${compIdx + 1}`);
//       let newSheetName = baseSheetName;
//       // ensure uniqueness
//       let suffix = 1;
//       while (usedNames.has(newSheetName)) {
//         newSheetName = `${baseSheetName} ${suffix++}`;
//       }
//       usedNames.add(newSheetName);

//       // clone template sheet and insert into workbook
//       const newSheet = cloneSheet(templateSheet);
//       // set new sheet into workbook
//       workbook.SheetNames.push(newSheetName);
//       workbook.Sheets[newSheetName] = newSheet;

//       console.log(`Created sheet "${newSheetName}" for company index ${compIdx + 1}`);

//       // each company writes into its own sheet starting at START_COL
//       const baseColIndex = START_COL;
//       writeCompanyIntoSheet(company, newSheet, baseColIndex);

//       // optional: debug show first 10x10 of new sheet in console
//       console.log(`Preview of ${newSheetName} (cells ${colLetter(baseColIndex)}1..${colLetter(baseColIndex + 9)}10):`);
//       for (let r = 1; r <= 10; r++) {
//         let rowDump = `${r}: `;
//         for (let c = baseColIndex; c < baseColIndex + 10; c++) {
//           const addr = `${colLetter(c)}${r}`;
//           rowDump += `${
//             workbook.Sheets[newSheetName][addr] ? workbook.Sheets[newSheetName][addr].v : "undefined"
//           }; `;
//         }
//         console.log(rowDump);
//       }
//     });

//     // finally update workbook-level ranges for each newly created sheet
//     // Expand template sheet range using the parsed existingRef start column
//     try {
//       const parsedStartColLetter = (existingRef || "A1").split(":")[0].replace(/[0-9]/g, "") || "A";
//       const parsedStartColIndex = colIndexFromLetter(parsedStartColLetter);
//       expandSheetRange(
//         templateSheet,
//         parsedStartColIndex,
//         1,
//         Math.max(globalMaxCol, parsedStartColIndex),
//         Math.max(globalMaxRow, 1)
//       );
//     } catch (err) {
//       // ignore if templateRef parsing failed
//       console.warn("Could not expand template sheet range automatically:", err);
//     }

//     // Also ensure each new sheet has a proper !ref. We'll set a conservative range using global maxes:
//     const conservativeMinCol = 0;
//     const conservativeMinRow = 1;
//     const conservativeMaxCol = Math.max(globalMaxCol, conservativeMinCol + 10);
//     const conservativeMaxRow = Math.max(globalMaxRow, conservativeMinRow + 20);
//     workbook.SheetNames.forEach((sn) => {
//       const sh = workbook.Sheets[sn];
//       if (!sh["!ref"]) {
//         sh["!ref"] = `${colLetter(conservativeMinCol)}${conservativeMinRow}:${colLetter(
//           conservativeMaxCol
//         )}${conservativeMaxRow}`;
//       }
//     });

//     // write workbook to blob and save
//     const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([wbout], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
//     console.log("Excel exported successfully.");
//   }; // end performExport

//   const handleManualExport = async () => {
//     try {
//       await performExport(apiData);
//       setExported(true);
//       setLastExportAt(new Date());
//     } catch (err) {
//       console.error("Manual export failed:", err);
//       alert("Export failed — see console for details.");
//     }
//   };

//   if (loading) return <div>Loading API data...</div>;
//   if (error) return <div style={{ color: "red" }}>{error}</div>;

//   return (
//     <div style={{ padding: 12 }}>
//       <h3>Excel CGD Exporter</h3>
//       <div style={{ marginBottom: 8 }}>
//         <button onClick={handleManualExport} style={{ padding: "8px 12px" }}>
//           Export now
//         </button>{" "}
//         {exported && lastExportAt && <small>Last exported: {lastExportAt.toLocaleString()}</small>}
//       </div>

//       <div style={{ marginTop: 8 }}>
//         <strong>Configuration</strong>
//         <div>Template filename: {TEMPLATE_FILENAME}</div>
//         <div>Template sheet name: {sheetName}</div>
//         <div>
//           Start column (zero-based): {START_COL} → {colLetter(START_COL)} • Append mode:{" "}
//           {APPEND_IF_NONEMPTY ? "ON" : "OFF"}
//         </div>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <strong>API sample (first object)</strong>
//         <pre style={{ maxHeight: 240, overflow: "auto", background: "#f6f6f6", padding: 8 }}>
//           {apiData && apiData.length > 0 ? JSON.stringify(apiData[0], null, 2) : "No data"}
//         </pre>
//       </div>

//       <div style={{ marginTop: 12 }}>
//         <small>
//           Check the browser console for detailed logs showing where values were written and the sheet creation
//           steps.
//         </small>
//       </div>
//     </div>
//   );
// };

// export default ExcelCGD;









import React, { useEffect, useState, } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import apiClient from "../../api/axiosClient";
import { useNavigate } from "react-router-dom";

const TEMPLATE_FILENAME = "CGD Company of the Year 2025-28.07final.xlsx";
const STATIC_BASE_DATE = "31/03/2025";

// exact row mapping (must match your template)
const rowMapping = {
  organisationname: 2,
  MWP_10: 4,
  MWP_8: 5,
  MWP_5: 6,
  MWP_3: 7,
  MWP_no: 8,
  ganame:9,
  basedate: 10,
  start_date: 11,
  period: 12,
  force_start: 13,
  force_end: 14,
    force_start2:15,
  force_end2:16,
  mwp_target_png: 19,
  pro_rated_MWP: 20,
  actual_png: 21, // adjust if needed
  billed_png: 22,
  mwp_target_cng: 25,
  pro_rated_MWP_cng: 26,
  actual_cng: 27,
  mwp_target_inch: 30,
  pro_rated_MWP_inch: 31,
  actual_inch: 32,
  png_sales: 35,
  cng_sales: 36,
  cbg_intakes: 37,
  fatalities: 39,
  hours_workout: 40,
  lost_time: 41,
  incidents: 42,
  safety: 43,
};

const aliasKeyMap = {
  ga10YearMWP: "MWP_10",
  ga8YearMWP: "MWP_8",
  ga5YearMWP: "MWP_5",
  ga3YearMWP: "MWP_3",
  gaNoMWP: "MWP_no",
  Organisation_name: "organisationname",
  gaNames: "ganame",
  organisation_name: "organisationname",
  organisationname: "organisationname",
  baseDate: "basedate",
  startWorkDate: "start_date",
  exclusivityPeriod: "period",
  forceMajeureStart: "force_start",
  forceMajeureEnd: "force_end",
    forceMajeureStart2: "force_start2",
  forceMajeureEnd2: "force_end2",
  pngTotalMWP: "mwp_target_png",
  pngProRatedMWP: "pro_rated_MWP",
  pngActual: "actual_png",
  pngBilled: "billed_png",
  cngTotalMWP: "mwp_target_cng",
  cngProRatedMWP: "pro_rated_MWP_cng",
  cngActual: "actual_cng",
  pipelineTotalMWP: "mwp_target_inch",
  pipelineProRatedMWP: "pro_rated_MWP_inch",
  pipelineActual: "actual_inch",
  pngSalesVolume: "png_sales",
  cngSalesVolume: "cng_sales",
  cbgIntake: "cbg_intakes",
  fatalities: "fatalities",
  totalHoursWorked: "hours_workout",
  lostTimeInjuries: "lost_time",
  totalRecordableIncident: "incidents",
  safetyAudits: "safety",
};

const colLetter = (colIndex) => {
  let letters = "";
  while (colIndex >= 0) {
    letters = String.fromCharCode((colIndex % 26) + 65) + letters;
    colIndex = Math.floor(colIndex / 26) - 1;
  }
  return letters;
};

const colIndexFromLetter = (col) => {
  let index = 0;
  for (let i = 0; i < col.length; i++) {
    index = index * 26 + (col.charCodeAt(i) - 65 + 1);
  }
  return index - 1;
};

const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
  const start = `${colLetter(minCol)}${minRow}`;
  const end = `${colLetter(maxCol)}${maxRow}`;
  sheet["!ref"] = `${start}:${end}`;
};

// --- Robust sanitizer that ensures final sheet name <= 31 chars ---
const MAX_SHEET_NAME = 31;

const sanitizeSheetName = (name) => {
  // Remove invalid characters for Excel and collapse whitespace
  let s = name ? String(name) : "";
  s = s.replace(/[:\\\/\?\*\[\]]/g, " ").replace(/\s+/g, " ").trim();
  if (!s) s = "Calculation";
  // If already within limit, return it
  if (s.length <= MAX_SHEET_NAME) return s;
  // Otherwise truncate smartly: keep as much start as possible
  return s.slice(0, MAX_SHEET_NAME);
};

const ExcelCGD = () => {
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [exported, setExported] = useState(false);
  const [lastExportAt, setLastExportAt] = useState(null);
    const navigate = useNavigate();

  // CONFIG
  const START_COL = 3; // zero-based (3 => column D)
  const sheetName = "Calculation - Company A"; // template sheet name to copy
  const APPEND_IF_NONEMPTY = true; // when ON, if target occupied, find next empty column in same row

  useEffect(() => {
    (async () => {
      try {
        const resp = await apiClient.get("/registration-cgd/submitted/");
        const results = (resp.data && (resp.data.results ?? resp.data)) || [];
        console.log("API results length:", results.length);
        console.log("Sample API object (0):", results[0]);
        setApiData(results);
      } catch (err) {
        console.error("API fetch error:", err);
        setError("Failed to fetch API data. See console.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!loading && !error && apiData && apiData.length > 0 && !exported) {
      (async () => {
        try {
          await performExport(apiData);
          setExported(true);
          setLastExportAt(new Date());
        } catch (err) {
          console.error("Auto-export failed:", err);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, apiData, exported]);

  const getRowMappingForKey = (key) => {
    if (!key) return undefined;
    if (rowMapping[key] !== undefined) return rowMapping[key];
    if (aliasKeyMap[key] && rowMapping[aliasKeyMap[key]] !== undefined)
      return rowMapping[aliasKeyMap[key]];
    const normalized = key.toLowerCase().replace(/[^a-z0-9]/g, "");
    for (const rk of Object.keys(rowMapping)) {
      if (rk.toLowerCase().replace(/[^a-z0-9]/g, "") === normalized) return rowMapping[rk];
    }
    return undefined;
  };

  const resolveMergeCell = (sheet, r, c) => {
    const merges = sheet["!merges"] || [];
    for (const m of merges) {
      if (r >= m.s.r && r <= m.e.r && c >= m.s.c && c <= m.e.c) {
        return { r: m.s.r, c: m.s.c };
      }
    }
    return { r, c };
  };

  // find the next empty column (zero-based) in a given row (1-based rowNumber), starting from startColZero
  const findNextEmptyCol = (sheet, rowOneBased, startColZero) => {
    const MAX_CHECK = 10000;
    let c = startColZero;
    for (let i = 0; i < MAX_CHECK; i++, c++) {
      const addr = `${colLetter(c)}${rowOneBased}`;
      const cell = sheet[addr];
      if (!cell || cell.v === undefined || cell.v === null || cell.v === "") {
        return c;
      }
    }
    return startColZero;
  };



  const performExport = async (dataToWrite) => {
  if (!dataToWrite || dataToWrite.length === 0) {
    throw new Error("No API data to export.");
  }

  const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
  console.log("Fetching template:", url);
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

  const contentType = resp.headers.get("content-type") || "";
  if (contentType.includes("text/html")) {
    const txt = await resp.text();
    console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
    throw new Error("Template returned HTML. Check file path/name.");
  }

  const arrayBuffer = await resp.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: "array" });

  const templateSheet = workbook.Sheets[sheetName];
  if (!templateSheet) {
    throw new Error(
      `Sheet "${sheetName}" not found in workbook. Available: ${workbook.SheetNames.join(", ")}`
    );
  }
  console.log("Using template sheet:", sheetName, "initial !ref:", templateSheet["!ref"]);

  const existingRef = templateSheet["!ref"] || "A1:A1";
  const usedNames = new Set(workbook.SheetNames);

  // Collect ALL sheets whose name starts with "Calculation -" (case-insensitive), preserving workbook order.
  const calcPrefixRegex = /^calculation\s*-/i;
  const calculationSheets = workbook.SheetNames.filter((n) => calcPrefixRegex.test(n));
  console.log("Calculation sheets found (in workbook order):", calculationSheets);

  // helper to deep-copy the template sheet object (preserves merges, cell addresses, etc.)
  const cloneSheet = (sheet) => JSON.parse(JSON.stringify(sheet));

  let globalMaxCol = 0;
  let globalMaxRow = 0;

  // reuse your existing writeCompanyIntoSheet logic, unchanged (I paste it here so function is self-contained)
//   const writeCompanyIntoSheet = (company, sheetObj, baseColIndex) => {
//     const companyKeys = Object.keys(company || {});
//     console.log("Writing into sheet; keys:", companyKeys.slice(0, 40));

//     companyKeys.forEach((key) => {
//       const mappedRow = getRowMappingForKey(key);
//       if (mappedRow == null) return; // no mapping, skip

//       // const value = company[key];
//       let value;

// if (key === "baseDate" || key === "basedate") {
//   value = STATIC_BASE_DATE;
// } else {
//   value = company[key];
// }


//       if (Array.isArray(value)) {
//         const flattened = value.flat(1);
//         flattened.forEach((elem, elemIdx) => {
//           let targetCol = baseColIndex + elemIdx;
//           const writeRow1Based = mappedRow;
//           let writeVal = elem === undefined || elem === null ? "" : elem;

//           if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//           if (typeof writeVal === "string") {
//             const trimmed = writeVal.trim();
//             const noCommas = trimmed.replace(/,/g, "");
//             if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//           }

//           const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
//           targetCol = cResolved;

//           if (APPEND_IF_NONEMPTY) {
//             const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//             const cell = sheetObj[addr];
//             if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//               const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
//               console.log(`Occupied ${addr} -> using ${colLetter(nextEmptyCol)}${writeRow1Based}`);
//               targetCol = nextEmptyCol;
//             }
//           }

//           const finalRZero = writeRow1Based - 1;
//           const finalCZero = targetCol;

//           try {
//             XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//             const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//             const newCell = sheetObj[cellAddr];
//             if (newCell) {
//               if (typeof writeVal === "number") newCell.t = "n";
//               else if (typeof writeVal === "boolean") newCell.t = "b";
//               else newCell.t = "s";
//             }
//           } catch (e) {
//             console.error("Failed writing array cell", key, elemIdx, e);
//             sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
//               t: typeof writeVal === "number" ? "n" : "s",
//               v: writeVal,
//             };
//           }

//           globalMaxCol = Math.max(globalMaxCol, finalCZero);
//           globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
//         });
//       } else {
//         // scalar
//         let targetCol = baseColIndex;
//         let writeRow1Based = mappedRow;
//         let writeVal = value === undefined || value === null ? "" : value;
//         if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
//         if (typeof writeVal === "string") {
//           const trimmed = writeVal.trim();
//           const noCommas = trimmed.replace(/,/g, "");
//           if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
//         }

//         const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
//         targetCol = cResolved;

//         if (APPEND_IF_NONEMPTY) {
//           const addr = `${colLetter(targetCol)}${writeRow1Based}`;
//           const cell = sheetObj[addr];
//           if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
//             const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
//             targetCol = nextEmptyCol;
//           }
//         }

//         const finalRZero = writeRow1Based - 1;
//         const finalCZero = targetCol;

//         try {
//           XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
//           const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
//           const newCell = sheetObj[cellAddr];
//           if (newCell) {
//             if (typeof writeVal === "number") newCell.t = "n";
//             else if (typeof writeVal === "boolean") newCell.t = "b";
//             else newCell.t = "s";
//           }
//         } catch (e) {
//           console.error("Failed writing scalar", key, e);
//           sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
//             t: typeof writeVal === "number" ? "n" : "s",
//             v: writeVal,
//           };
//         }

//         globalMaxCol = Math.max(globalMaxCol, finalCZero);
//         globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
//       }
//     }); // end keys loop
//   }; // end writeCompanyIntoSheet

// --- add these helpers before writeCompanyIntoSheet ---

// return true if mappedRow should use two adjacent columns per element
const isDoubleColRow = (mappedRow) => {
  // rows 9 through 16 inclusive use double-column mapping (ganame..force_end2)
  return mappedRow >= 9 && mappedRow <= 16;
};

// find next column index where `width` consecutive cells on rowOneBased are empty
const findNextEmptyColForWidth = (sheet, rowOneBased, startColZero, width) => {
  const MAX_CHECK = 10000;
  let c = startColZero;
  outer: for (let i = 0; i < MAX_CHECK; i++, c++) {
    for (let w = 0; w < width; w++) {
      const addr = `${colLetter(c + w)}${rowOneBased}`;
      const cell = sheet[addr];
      if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
        // occupied -> move start to after this occupied cell and continue searching
        c = c + w; // next iteration will increment c by 1
        continue outer;
      }
    }
    // found `width` consecutive empty cols starting at c
    return c;
  }
  return startColZero;
};

// --- replace the existing writeCompanyIntoSheet with this updated version ---
const writeCompanyIntoSheet = (company, sheetObj, baseColIndex) => {
  const companyKeys = Object.keys(company || {});
  console.log("Writing into sheet; keys:", companyKeys.slice(0, 40));

  companyKeys.forEach((key) => {
    const mappedRow = getRowMappingForKey(key);
    if (mappedRow == null) return; // no mapping, skip

    // handle STATIC_BASE_DATE substitution
    let value;
     {
      value = company[key];
    }

    const doubleCol = isDoubleColRow(mappedRow);

    if (Array.isArray(value)) {
      const flattened = value.flat(1);
      flattened.forEach((elem, elemIdx) => {
        // for double-col rows each element occupies two adjacent columns
        let targetCol = baseColIndex + (doubleCol ? elemIdx * 2 : elemIdx);
        const writeRow1Based = mappedRow;
        let writeVal = elem === undefined || elem === null ? "" : elem;

        if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
        if (typeof writeVal === "string") {
          const trimmed = writeVal.trim();
          const noCommas = trimmed.replace(/,/g, "");
          if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
        }

        // if cell falls inside a merge, resolve to its top-left
        const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
        targetCol = cResolved;

        if (APPEND_IF_NONEMPTY) {
          if (doubleCol) {
            // need two consecutive empty columns
            const nextEmptyCol = findNextEmptyColForWidth(sheetObj, writeRow1Based, targetCol, 2);
            if (nextEmptyCol !== targetCol) {
              console.log(`Occupied at ${colLetter(targetCol)}${writeRow1Based} -> using ${colLetter(nextEmptyCol)}${writeRow1Based} (double width)`);
            }
            targetCol = nextEmptyCol;
          } else {
            const addr = `${colLetter(targetCol)}${writeRow1Based}`;
            const cell = sheetObj[addr];
            if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
              const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
              console.log(`Occupied ${addr} -> using ${colLetter(nextEmptyCol)}${writeRow1Based}`);
              targetCol = nextEmptyCol;
            }
          }
        }

        const finalRZero = writeRow1Based - 1;
        const finalCZero = targetCol;

        try {
          // write into first column
          XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
          const cellAddr1 = `${colLetter(finalCZero)}${finalRZero + 1}`;
          const newCell1 = sheetObj[cellAddr1];
          if (newCell1) {
            if (typeof writeVal === "number") newCell1.t = "n";
            else if (typeof writeVal === "boolean") newCell1.t = "b";
            else newCell1.t = "s";
          }

          // if doubleCol, duplicate into adjacent column as well
          if (doubleCol) {
            const secondCZero = finalCZero + 1;
            XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: secondCZero } });
            const cellAddr2 = `${colLetter(secondCZero)}${finalRZero + 1}`;
            const newCell2 = sheetObj[cellAddr2];
            if (newCell2) {
              if (typeof writeVal === "number") newCell2.t = "n";
              else if (typeof writeVal === "boolean") newCell2.t = "b";
              else newCell2.t = "s";
            }
            globalMaxCol = Math.max(globalMaxCol, secondCZero);
          } else {
            globalMaxCol = Math.max(globalMaxCol, finalCZero);
          }
        } catch (e) {
          console.error("Failed writing array cell", key, elemIdx, e);
          // fallback: set cell(s) manually
          sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
            t: typeof writeVal === "number" ? "n" : "s",
            v: writeVal,
          };
          if (doubleCol) {
            sheetObj[`${colLetter(finalCZero + 1)}${mappedRow}`] = {
              t: typeof writeVal === "number" ? "n" : "s",
              v: writeVal,
            };
            globalMaxCol = Math.max(globalMaxCol, finalCZero + 1);
          } else {
            globalMaxCol = Math.max(globalMaxCol, finalCZero);
          }
        }

        globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
      });
    } else {
      // scalar
      let targetCol = baseColIndex;
      let writeRow1Based = mappedRow;
      let writeVal = value === undefined || value === null ? "" : value;
      if (typeof writeVal === "object") writeVal = JSON.stringify(writeVal);
      if (typeof writeVal === "string") {
        const trimmed = writeVal.trim();
        const noCommas = trimmed.replace(/,/g, "");
        if (noCommas !== "" && /^-?\d+(\.\d+)?$/.test(noCommas)) writeVal = Number(noCommas);
      }

      const { r: rResolved, c: cResolved } = resolveMergeCell(sheetObj, mappedRow - 1, targetCol);
      targetCol = cResolved;

      if (APPEND_IF_NONEMPTY) {
        if (doubleCol) {
          const nextEmptyCol = findNextEmptyColForWidth(sheetObj, writeRow1Based, targetCol, 2);
          targetCol = nextEmptyCol;
        } else {
          const addr = `${colLetter(targetCol)}${writeRow1Based}`;
          const cell = sheetObj[addr];
          if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
            const nextEmptyCol = findNextEmptyCol(sheetObj, writeRow1Based, targetCol + 1);
            targetCol = nextEmptyCol;
          }
        }
      }

      const finalRZero = writeRow1Based - 1;
      const finalCZero = targetCol;

      try {
        XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: finalCZero } });
        const cellAddr = `${colLetter(finalCZero)}${finalRZero + 1}`;
        const newCell = sheetObj[cellAddr];
        if (newCell) {
          if (typeof writeVal === "number") newCell.t = "n";
          else if (typeof writeVal === "boolean") newCell.t = "b";
          else newCell.t = "s";
        }

        if (doubleCol) {
          const secondCZero = finalCZero + 1;
          XLSX.utils.sheet_add_aoa(sheetObj, [[writeVal]], { origin: { r: finalRZero, c: secondCZero } });
          const cellAddr2 = `${colLetter(secondCZero)}${finalRZero + 1}`;
          const newCell2 = sheetObj[cellAddr2];
          if (newCell2) {
            if (typeof writeVal === "number") newCell2.t = "n";
            else if (typeof writeVal === "boolean") newCell2.t = "b";
            else newCell2.t = "s";
          }
          globalMaxCol = Math.max(globalMaxCol, secondCZero);
        } else {
          globalMaxCol = Math.max(globalMaxCol, finalCZero);
        }
      } catch (e) {
        console.error("Failed writing scalar", key, e);
        sheetObj[`${colLetter(finalCZero)}${mappedRow}`] = {
          t: typeof writeVal === "number" ? "n" : "s",
          v: writeVal,
        };
        if (doubleCol) {
          sheetObj[`${colLetter(finalCZero + 1)}${mappedRow}`] = {
            t: typeof writeVal === "number" ? "n" : "s",
            v: writeVal,
          };
          globalMaxCol = Math.max(globalMaxCol, finalCZero + 1);
        } else {
          globalMaxCol = Math.max(globalMaxCol, finalCZero);
        }
      }

      globalMaxRow = Math.max(globalMaxRow, finalRZero + 1);
    }
  }); // end keys loop
}; // end writeCompanyIntoSheet


  // ---- MAIN MAPPING: map organisation index -> pre-declared Calculation sheet at same index ----
  dataToWrite.forEach((company, compIdx) => {
    // prefer the pre-declared calculation sheet at the same index (0 -> first, 1 -> second, ...)
    let targetSheetName = calculationSheets[compIdx];

    if (targetSheetName) {
      console.log(`Mapping organisation index ${compIdx} -> existing sheet "${targetSheetName}"`);
    } else {
      // fallback behavior: create a new cloned sheet if no pre-made sheet exists for this index.
      // If you want strict mapping only (no creation), change this block to throw an error instead.
      console.warn(
        `No pre-declared Calculation sheet for organisation index ${compIdx}. Creating a new sheet as fallback.`
      );
      const newSheetBase = `Calculation - Company (auto ${compIdx + 1})`;
      let newSheetName = sanitizeSheetName(newSheetBase);
      let cnt = 1;
      while (usedNames.has(newSheetName)) {
        const suffix = ` (${cnt})`;
        const maxBase = MAX_SHEET_NAME - suffix.length;
        newSheetName = `${newSheetName.slice(0, Math.max(0, maxBase))}${suffix}`;
        cnt++;
      }
      const newSheet = cloneSheet(templateSheet);
      workbook.SheetNames.push(newSheetName);
      workbook.Sheets[newSheetName] = newSheet;
      usedNames.add(newSheetName);
      targetSheetName = newSheetName;
      console.log(`Created fallback sheet "${newSheetName}" for index ${compIdx}`);
    }

    // write into chosen sheet starting at START_COL
    const sheetObj = workbook.Sheets[targetSheetName];
    const baseColIndex = START_COL;
    writeCompanyIntoSheet(company, sheetObj, baseColIndex);

    // debug preview
    console.log(
      `Preview of ${targetSheetName} (cells ${colLetter(baseColIndex)}1..${colLetter(
        baseColIndex + 9
      )}10):`
    );
    for (let r = 1; r <= 10; r++) {
      let rowDump = `${r}: `;
      for (let c = baseColIndex; c < baseColIndex + 10; c++) {
        const addr = `${colLetter(c)}${r}`;
        rowDump += `${workbook.Sheets[targetSheetName][addr] ? workbook.Sheets[targetSheetName][addr].v : "undefined"}; `;
      }
      console.log(rowDump);
    }
  });

  // update ranges for template and other sheets (same logic as before)
  try {
    const parsedStartColLetter = (existingRef || "A1").split(":")[0].replace(/[0-9]/g, "") || "A";
    const parsedStartColIndex = colIndexFromLetter(parsedStartColLetter);
    expandSheetRange(
      templateSheet,
      parsedStartColIndex,
      1,
      Math.max(globalMaxCol, parsedStartColIndex),
      Math.max(globalMaxRow, 1)
    );
  } catch (err) {
    console.warn("Could not expand template sheet range automatically:", err);
  }

  const conservativeMinCol = 0;
  const conservativeMinRow = 1;
  const conservativeMaxCol = Math.max(globalMaxCol, conservativeMinCol + 10);
  const conservativeMaxRow = Math.max(globalMaxRow, conservativeMinRow + 20);
  workbook.SheetNames.forEach((sn) => {
    const sh = workbook.Sheets[sn];
    if (!sh["!ref"]) {
      sh["!ref"] = `${colLetter(conservativeMinCol)}${conservativeMinRow}:${colLetter(
        conservativeMaxCol
      )}${conservativeMaxRow}`;
    }
  });

  // write workbook to blob and save
  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
  console.log("Excel exported successfully.");
}; // end performExport

  const handleManualExport = async () => {
    try {
      await performExport(apiData);
      setExported(true);
      setLastExportAt(new Date());
    } catch (err) {
      console.error("Manual export failed:", err);
      alert("Export failed — see console for details.");
    }
  };

  if (loading) return <div>Loading API data...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
   
       <>
    {navigate("/Thankyou")}
    </>
  );
};

export default ExcelCGD;
